<div class="slideShow">
  <img [src]=imgUrl alt="img">
</div>
